module.exports = __webpack_public_path__ + "static/media/black-bell.f37041bf.webp";